import type { ReactNode } from 'react'

type IconName = 'home' | 'search' | 'heart' | 'bag' | 'arrow' | 'back' | 'plus' | 'minus' | 'close' | 'truck' | 'info' | 'menu' | 'ticket' | 'sun' | 'moon'

type IconProps = {
  name: IconName
  size?: number
  stroke?: number
}

const paths: Record<IconName, ReactNode> = {
  home: <path d="M3.5 10.5 12 3l8.5 7.5v9a1.5 1.5 0 0 1-1.5 1.5h-14A1.5 1.5 0 0 1 3.5 19.5v-9Z M9 21v-6h6v6" />,
  search: <><circle cx="10.6" cy="10.6" r="6.8" /><path d="m16 16 4.2 4.2" /></>,
  heart: <path d="M20.7 8.4c0 5.9-8.7 11.1-8.7 11.1S3.3 14.3 3.3 8.4A4.7 4.7 0 0 1 12 5.8a4.7 4.7 0 0 1 8.7 2.6Z" />,
  bag: <><path d="M5.2 8.5h13.6l1.1 12H4.1l1.1-12Z" /><path d="M8.5 9V6.7a3.5 3.5 0 0 1 7 0V9" /></>,
  arrow: <path d="M5 12h13M13 6l6 6-6 6" />,
  back: <path d="m15 4-8 8 8 8" />,
  plus: <path d="M12 5v14M5 12h14" />,
  minus: <path d="M5 12h14" />,
  close: <path d="m5 5 14 14M19 5 5 19" />,
  truck: <><path d="M3.5 5.5h11v11h-11zM14.5 9h3.2l2.8 3v4.5h-6" /><circle cx="7.3" cy="18" r="1.7" /><circle cx="17.7" cy="18" r="1.7" /></>,
  info: <><circle cx="12" cy="12" r="9" /><path d="M12 10.5V17M12 7h.01" /></>,
  menu: <path d="M4 6h16M4 12h16M4 18h16" />,
  ticket: <path d="M4 7.5A2.5 2.5 0 0 0 6.5 5h11A2.5 2.5 0 0 0 20 7.5v1a2.5 2.5 0 0 0 0 5v1a2.5 2.5 0 0 0-2.5 2.5h-11A2.5 2.5 0 0 0 4 14.5v-1a2.5 2.5 0 0 0 0-5v-1Z" />,
  sun: <><circle cx="12" cy="12" r="4" /><path d="M12 2.5v2M12 19.5v2M21.5 12h-2M4.5 12h-2M18.7 5.3l-1.4 1.4M6.7 17.3l-1.4 1.4M18.7 18.7l-1.4-1.4M6.7 6.7 5.3 5.3" /></>,
  moon: <path d="M20.4 15.1A8.9 8.9 0 0 1 8.9 3.6 8.9 8.9 0 1 0 20.4 15.1Z" />
}

export function Icon({ name, size = 24, stroke = 1.7 }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      className="icon"
      fill="none"
      height={size}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={stroke}
      viewBox="0 0 24 24"
      width={size}
    >
      {paths[name]}
    </svg>
  )
}
